function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  opacity: 0.2,
  d: "M0 0h16v16H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7 14.3l-3.1-3.1A6.847 6.847 0 0014 7a6.957 6.957 0 00-7-7 6.957 6.957 0 00-7 7 6.957 6.957 0 007 7 6.847 6.847 0 004.2-1.4l3.1 3.1zM2 7a4.951 4.951 0 015-5 4.951 4.951 0 015 5 4.951 4.951 0 01-5 5 4.951 4.951 0 01-5-5z",
  fill: "#999"
});

function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDpub25lO29wYWNpdHk6MC4yO30uYntmaWxsOiM5OTk7fTwvc3R5bGU+PC9kZWZzPjxyZWN0IGNsYXNzPSJhIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDApIi8+PHBhdGggY2xhc3M9ImIiIGQ9Ik0xNS43LDE0LjNsLTMuMS0zLjFBNi44NDcsNi44NDcsMCwwLDAsMTQsNyw2Ljk1Nyw2Ljk1NywwLDAsMCw3LDAsNi45NTcsNi45NTcsMCwwLDAsMCw3YTYuOTU3LDYuOTU3LDAsMCwwLDcsNyw2Ljg0Nyw2Ljg0NywwLDAsMCw0LjItMS40bDMuMSwzLjFaTTIsN0E0Ljk1MSw0Ljk1MSwwLDAsMSw3LDJhNC45NTEsNC45NTEsMCwwLDEsNSw1LDQuOTUxLDQuOTUxLDAsMCwxLTUsNUE0Ljk1MSw0Ljk1MSwwLDAsMSwyLDdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwKSIvPjwvc3ZnPg==";
export { SvgIconSearch as ReactComponent };